import React from "react";
export default function PrivacyPolicyHero() {
  return <section id="privacypolicyhero" className="bg-background py-16 md:py-24 lg:py-32 border-b border-border flex flex-col items-center justify-center text-center">
      <div className="container px-4 md:px-6">
        <div className="max-w-3xl mx-auto space-y-6">
          <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-primary">
            Privacy Policy
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground font-medium">
            Effective Date: 20 June 2026
          </p>
        </div>
      </div>
    </section>;
}